import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { colors } from '../../../defaultTheme';
const LogoContainer = styled.div `
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  height: ${({ size }) => 16 * size}px;
  width: ${({ size }) => 12.12 * size}px;
`;
const CommonBarStyles = styled.div `
  width: 28%;
  position: absolute;
  background-color: ${({ color }) => color};
`;
const LeftBarKeyframes = keyframes `
  0% { height: 0 }
  20% { height: 50% }
  40% { height: 50% }
  60% { height: 50% }
  80% { height: 0; top: 50%}
  100% { height: 0; }
`;
const LeftBarAnimation = css `
  animation: ${LeftBarKeyframes} 1.8s ease infinite;
`;
const MiddleBarKeyframes = keyframes `
  0% { height: 0 }
  20% { height: 0 }
  40% { height: 100% }
  60% { height: 100% }
  80% { height: 100% }
  100% { height: 0 }
`;
const MiddleBarAnimation = css `
  animation: ${MiddleBarKeyframes} 1.8s ease infinite;
`;
const RightBarKeyframes = keyframes `
  0% { height: 0 }
  20% { height: 0 }
  40% { height: 0 }
  60% { height: 50%; top: 0 }
  80% { height: 0; top: 50%}
  100% { height: 0 }
`;
const RightBarAnimation = css `
  animation: ${RightBarKeyframes} 1.8s ease infinite;
`;
const LeftBar = styled(CommonBarStyles) `
  ${LeftBarAnimation};
  bottom: 0;
  left: 0;
`;
const MiddleBar = styled(CommonBarStyles) `
  ${MiddleBarAnimation};
`;
const RightBar = styled(CommonBarStyles) `
  ${RightBarAnimation};
  top: 0;
  right: 0;
`;
const SyfLoader = ({ size = 1, id = 'syf-loader', className, leftBarcolor = colors.syfYellow, middleBarcolor = colors.syfYellow, rightBarcolor = colors.syfYellow }) => {
    return (React.createElement(LogoContainer, { className: className, role: "img", "aria-label": "Content Loading", id: id, size: size },
        React.createElement(LeftBar, { color: leftBarcolor }),
        React.createElement(MiddleBar, { color: middleBarcolor }),
        React.createElement(RightBar, { color: rightBarcolor })));
};
export default SyfLoader;
